import { useEffect, useState } from 'react';

const useIsMobile = (
  breakpoint: number = 768
): { isMobile: boolean | undefined; isLoading: boolean; width: number } => {
  const [isMobile, setIsMobile] = useState<boolean>(
    typeof window !== 'undefined' ? window.innerWidth < breakpoint : false
  );
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [width, setWidth] = useState<number>(typeof window !== 'undefined' ? window.innerWidth : 0);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < breakpoint);
      setWidth(window.innerWidth);
      setIsLoading(false);
    };

    checkIsMobile();

    window.addEventListener('resize', checkIsMobile);

    return () => window.removeEventListener('resize', checkIsMobile);
  }, [breakpoint]);

  return { isMobile, isLoading, width };
};

export default useIsMobile;
